import React, { Component } from 'react'
import FaClip from 'react-icons/lib/fa/clipboard'
import FaCheck from 'react-icons/lib/fa/check'
import { Link } from 'react-router'
import ClipboardButton from 'react-clipboard.js'

export default class VideoUrl extends Component {
  constructor() {
    super()
    this.state = {
      copied: false,
    }
  }

  render() {
    const { url, shortcode } = this.props
    if (!url) {
      return (<div></div>)
    }

    return (
      <div style={{ position: 'relative' }} className="video-url">
        <a id="video-url-input" ref="input" href={url} target="_blank" value={url}>{url}</a>
        <ClipboardButton
          component="button"
          data-clipboard-text={url}
          onSuccess={() => {
            window.ga('send', 'event', 'Shares', 'copied', 'dashboard')
            this.setState({ copied: true })
            setTimeout(
                () => {
                  this.setState({ copied: false })
                },
                3000,
              )
          }}
        >
          {this.state.copied ? <FaCheck style={{ color: 'green' }} /> : <FaClip />}
        </ClipboardButton>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/videos/videoItem/VideoUrl.js